import { AccountBalance, ChromeReaderMode, ExitToApp, LockOpen, Person, School } from '@mui/icons-material';
import { Routing } from '@fabiulous/routing/dist/types';

import { Dictionary } from '@shared/dictionary';

export const routes = {
  home: '/',
  onboarding: '/onboarding',
  auth: {
    path: '/auth',
    routes: {
      impersonateUser: '/impersonate',
      login: '/login',
      resetPasswordConfirm: '/reset-password-confirm',
      resetPassword: (reason: ':reason' | 'forgotten' | 'forced' = ':reason') => `/reset-password/${reason}`,
      signup: (companySlug?: string) => companySlug ? `/signup/${companySlug}` : '/signup',
    },
  },
  users: {
    path: '/users',
    routes: {
      create: '/create',
      edit: (userId: string | number = ':userId') => `/edit/${userId}`,
      invite: (token: string = ':token') => `/invitation/${token}`,
    },
  },
  profile: '/profile',
  feedback: '/feedback',
  understandMatches: '/understand-matches',
  disciplines: {
    path: '/disciplines',
    routes: {
      view: (disciplineId: string | number = ':disciplineId') => ({
        path: `/${disciplineId}`,
        routes: {
          assertions: '/assertions',
          majors: '/majors',
        },
      }),
    },
  },
  majors: {
    path: '/majors',
    routes: {
      view: (majorId: string | number = ':majorId') => ({
        path: `/${majorId}`,
        routes: {
          assertions: '/assertions',
          specializations: {
            path: '/specializations',
            routes: {
              view: (specializationId: string | number = ':specializationId') => ({
                path: `/${specializationId}`,
                routes: {
                  universities: '/universities',
                },
              }),
            },
          },
        },
      }),
    },
  },
  universities: {
    path: '/universities',
    routes: {
      view: (universityId: string | number = ':universityId') => ({
        path: `/${universityId}`,
        routes: {
          assertions: '/assertions',
          majors: {
            path: '/majors',
            routes: {
              view: (majorId: string | number = ':majorId') => ({
                path: `/${majorId}`,
                routes: {
                  specializations: {
                    path: '/specializations',
                    routes: {
                      view: (specializationId: string | number = ':specializationId') => `/${specializationId}`,
                    },
                  },
                },
              }),
            },
          },
        },
      }),
    },
  },
};

export const navigation = (router: Routing.RecursiveRoutes<typeof routes>, dictionary: Dictionary): CVT.Navigation.Config => ({
  userMenu: [{
    icon: <LockOpen />,
    text: dictionary.menu.auth.login,
    route: router.auth.login.path,
    requiresAuth: false,
  }, {
    icon: <ExitToApp />,
    text: dictionary.menu.auth.signUp,
    route: router.auth.signup().path,
    requiresAuth: false,
  }],
  sidebar: [{
    icon: <Person />,
    text: dictionary.menu.dashboard,
    route: router.home.path,
  }, {
    divider: true,
  }, {
    icon: <AccountBalance />,
    text: dictionary.menu.disciplines,
    route: router.disciplines.path,
  }, {
    icon: <ChromeReaderMode />,
    text: dictionary.menu.majors,
    route: router.majors.path,
  }, {
    icon: <School />,
    text: dictionary.menu.universities,
    route: router.universities.path,
  }],
});
